import { commonActions } from 'srcReact/components'
import { dashboardConstants as dc } from './constants'
import { groupHomeService, groupService, dashboardService, workplaceService } from 'srcReact/services'
import { groupHomeActions } from 'srcReact/GroupHomePage'

export const dashboardActions = {
  getDashboardData,
  acceptSuggestMixR,
  rejectSuggestMixR,
  acceptNewMember,
  rejectNewMember,
  removeNewMember,
  renewInvitation,
  cancelInvitation,
  renewAllInvitations,
  clearData
}

function clearData() {
  return { type: dc.CLEAR_DATA }
}

function getDashboardData(type, id) {
  return (dispatch) => {
    dispatch(request({ type, id }))

    dashboardService.getDashboardData(type, id).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: dc.GET_DASHBOARD_DATA_REQUEST, response }
  }
  function success(response) {
    return { type: dc.GET_DASHBOARD_DATA_SUCCESS, response }
  }
  function failure(error) {
    return { type: dc.GET_DASHBOARD_DATA_FAILURE, error }
  }
}

function acceptSuggestMixR(mixrId) {
  return (dispatch) => {
    dispatch(request({ mixrId }))

    groupHomeService.suggestedAcceptMixr(mixrId).then(
      (response) => {
        dispatch(success(response, mixrId))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: dc.ACCEPT_SUGGEST_MIXR_REQUEST, response }
  }
  function success(response, mixrId) {
    return { type: dc.ACCEPT_SUGGEST_MIXR_SUCCESS, response, mixrId }
  }
  function failure(error) {
    return { type: dc.ACCEPT_SUGGEST_MIXR_FAILURE, error }
  }
}

function rejectSuggestMixR(mixrId) {
  return (dispatch) => {
    dispatch(request({ mixrId }))

    groupHomeService.suggestedRejectMixr(mixrId).then(
      (response) => {
        dispatch(success(response, mixrId))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: dc.REJECT_SUGGEST_MIXR_REQUEST, response }
  }
  function success(response, mixrId) {
    return { type: dc.REJECT_NEW_MEMBER_SUCCESS, response, mixrId }
  }
  function failure(error) {
    return { type: dc.REJECT_SUGGEST_MIXR_FAILURE, error }
  }
}

function acceptNewMember(groupId, userId) {
  return (dispatch) => {
    dispatch(request({ groupId, userId }))

    groupHomeService.memberPendingApprove(groupId, userId).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: dc.ACCEPT_NEW_MEMBER_REQUEST, response }
  }
  function success(response) {
    return { type: dc.ACCEPT_NEW_MEMBER_SUCCESS, response }
  }
  function failure(error) {
    return { type: dc.ACCEPT_NEW_MEMBER_FAILURE, error }
  }
}

function rejectNewMember(groupId, userId) {
  return (dispatch) => {
    dispatch(request({ groupId, userId }))

    groupHomeService.memberPendingReject(groupId, userId).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: dc.REJECT_NEW_MEMBER_REQUEST, response }
  }
  function success(response) {
    return { type: dc.REJECT_NEW_MEMBER_SUCCESS, response }
  }
  function failure(error) {
    return { type: dc.REJECT_NEW_MEMBER_FAILURE, error }
  }
}

function removeNewMember(type, objectId, userId, from, duration) {
  return (dispatch) => {
    dispatch(request({ objectId, userId }))
    let promise = null
    if (type === 'group') {
      promise = groupHomeService.removeFromGroup(groupId, userId)
    } else if (type === 'workplace') {
      promise = workplaceService.removeWorkplaceMember({ workplace_id: objectId, user_id: userId, dashboard: 1 })
    }

    promise.then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: dc.REMOVE_NEW_MEMBER_REQUEST, response }
  }
  function success(response) {
    return { type: dc.REMOVE_NEW_MEMBER_SUCCESS, response, userId, duration, from }
  }
  function failure(error) {
    return { type: dc.REMOVE_NEW_MEMBER_FAILURE, error }
  }
}

function renewInvitation(type, objectId, userId, emails) {
  return (dispatch) => {
    dispatch(request({ objectId, userId }))
    let promise = null
    if (type === 'group') {
      promise = groupService.sendInvites(objectId, userId.toString())
    } else if (type === 'workplace') {
      promise = workplaceService.inviteToWorkplace({ workplace_id: objectId, emails: emails })
    }

    promise.then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: dc.RENEW_INVITATION_REQUEST, response }
  }
  function success(response) {
    return { type: dc.RENEW_INVITATION_SUCCESS, response, userId }
  }
  function failure(error) {
    return { type: dc.RENEW_INVITATION_FAILURE, error }
  }
}

function cancelInvitation(type, objectId, userId) {
  return (dispatch) => {
    dispatch(request({ objectId, userId }))
    let promise = null
    if (type === 'group') {
      promise = groupService.cancelInvitation(objectId, userId)
    } else if (type === 'workplace') {
      promise = workplaceService.deleteWorkplaceInvitation({ invitation_id })
    }

    promise.then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: dc.CANCEL_INVITATION_REQUEST, response }
  }
  function success(response) {
    return { type: dc.CANCEL_INVITATION_SUCCESS, response, userId }
  }
  function failure(error) {
    return { type: dc.CANCEL_INVITATION_FAILURE, error }
  }
}

function renewAllInvitations(groupId) {
  return (dispatch) => {
    dispatch(request({ groupId }))

    groupService.resendInviteAll(groupId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: dc.RENEW_ALL_INVITATION_REQUEST, response }
  }
  function success(response) {
    return { type: dc.RENEW_ALL_INVITATION_SUCCESS, response, userId: -1 } //-1 is for renew all invitations
  }
  function failure(error) {
    return { type: dc.RENEW_ALL_INVITATION_FAILURE, error }
  }
}
